import React, { Component, PropTypes } from 'react';

import { get } from 'lodash';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { connect } from 'react-redux';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { CALCULATE_FONT_USAGE } from '../../../../constants/ActionTypes';
import FontConfigurator from '../../../widgets/FontConfigurator/FontConfigurator';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

const FontPropertySelect = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div>
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                defaultValue={defaultValue}
                isDisabled={isDisabled}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

const ButtonStylesColorSelect = ({ color, onColorChange, label }) => {
    return (
        <span className="col-lg-2 col-xs-12 col-sm-4">
            <div className="row">
                <div className="col-lg-2 col-xs-12 col-sm-8">
                    <PresetColorPicker color={color} onColorChange={onColorChange} />
                </div>
                <div className="col-lg-2 col-xs-12 col-sm-8">{label}</div>
            </div>
        </span>
    );
};

class IconLinkStyles extends Component {
    static defaultProps = {
        availableFontFamilies: {}
    };
    static propTypes = {
        children: PropTypes.element,
        settings: PropTypes.object,
        tagNameName: PropTypes.string
    };

    render() {
        const isDisabled = this.props.themeAccess || this.props.isDisabled;
        const fontSize = new CSSLength(this.props.colors.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const iconSize = new CSSLength(this.props.colors.icon['icon.size'], {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        const iconSize2 = iconSize.px;
        const iconSize3 = Math.round(iconSize2.substring(0, iconSize2.length - 2)) + 'px';

        const fontFamilies = [{ key: '', label: '' }].concat(
            Object.keys(this.props.availableFontFamilies).map(v => ({ key: v, label: v }))
        );
        const fontStyles = [{ key: '', label: '' }].concat(
            get(this.props.availableFontFamilies, [this.props.colors.font, 'styles'], []).map(v => ({
                key: v,
                label: v
            }))
        );
        const fontWeights = [{ key: '', label: '' }].concat(
            get(this.props.availableFontFamilies, [this.props.colors.font, 'weights'], []).map(v => ({
                key: v,
                label: v
            }))
        );
        return (
            <div className="ButtonStyles">
                <h4>{this.props.tagNameName}</h4>
                <div>{this.props.children}</div>
                <div
                    className="row"
                    style={{
                        marginTop: '15px'
                    }}
                >
                    <div className="col-lg-3 col-xs-12">
                        <div className="row">
                            <div className="col-xs-6">ICON COLOR</div>
                            <div className="col-xs-6">FONT COLOR</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.icon.color.normal}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onIconColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'normal'
                                    )}
                                />
                            </div>
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.color.normal}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onFontColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'normal'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-xs-12">
                        <div className="row">
                            <div className="col-xs-6">ICON COLOR</div>
                            <div className="col-xs-6">FONT COLOR</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.icon.color.hover}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onIconColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'hover'
                                    )}
                                />
                            </div>
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.color.hover}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onFontColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'hover'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-xs-12">
                        <div className="row">
                            <div className="col-xs-6">ICON COLOR</div>
                            <div className="col-xs-6">FONT COLOR</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.icon.color.active}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onIconColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'active'
                                    )}
                                />
                            </div>
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.color.active}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onFontColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'active'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-xs-12">
                        <div className="row">
                            <div className="col-xs-6">ICON COLOR</div>
                            <div className="col-xs-6">FONT COLOR</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.icon.color.disabled}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onIconColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'disabled'
                                    )}
                                />
                            </div>
                            <div className="col-xs-6">
                                <PresetColorPicker
                                    color={this.props.colors.color.disabled}
                                    isDisabled={isDisabled}
                                    onColorChange={this.props.onFontColorChange(
                                        this.props.layer,
                                        this.props.tagName,
                                        'disabled'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="row"
                    style={{
                        marginTop: '15px',
                        marginBottom: '30px'
                    }}
                >
                    <div className="col-lg-3 col-xs-12">
                        <FontPropertySelect
                            label="TEXT-DECORATION"
                            defaultValue={this.props.colors.textDecoration.normal}
                            values={['none', 'underline']}
                            isDisabled={isDisabled}
                            onChange={this.props.onTextDecorationChange('null', this.props.tagName, 'normal')}
                        />
                    </div>
                    <div className="col-lg-3 col-xs-12">
                        <FontPropertySelect
                            label="TEXT-DECORATION"
                            defaultValue={this.props.colors.textDecoration.hover}
                            isDisabled={isDisabled}
                            values={['none', 'underline']}
                            onChange={this.props.onTextDecorationChange('null', this.props.tagName, 'hover')}
                        />
                    </div>
                    <div className="col-lg-3 col-xs-12">
                        <FontPropertySelect
                            label="TEXT-DECORATION"
                            defaultValue={this.props.colors.textDecoration.active}
                            isDisabled={isDisabled}
                            values={['none', 'underline']}
                            onChange={this.props.onTextDecorationChange('null', this.props.tagName, 'active')}
                        />
                    </div>
                </div>
                <hr />
                <FontConfigurator
                    fontFamilyProperty="buttons.button.link.font"
                    fontStyleProperty="buttons.button.link.style"
                    fontWeightProperty="buttons.button.link.weight"
                    // prependHook={<div className="col-lg-1 col-xs-12 col-sm-8"></div>}
                >
                    <div className="col-xs-12 col-sm-3">
                        <FontPropertySelect
                            label="Text transform"
                            defaultValue={this.props.colors.textTransform}
                            isDisabled={isDisabled}
                            values={['uppercase', 'lowercase', 'capitalize', 'none']}
                            onChange={this.props.onTextTransformChange(this.props.layer, this.props.tagName)}
                        />
                    </div>
                </FontConfigurator>
                <div className="row">
                    <div className="col-xs-12 col-sm-3">
                        <FontPropertySelect
                            label="SIZE"
                            defaultValue={fontSize3}
                            isDisabled={isDisabled}
                            values={this.props.availableFontSizes}
                            onChange={this.props.onFontSizeChange(this.props.layer, this.props.tagName)}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        <FontPropertySelect
                            label="ICON SIZE"
                            defaultValue={iconSize3}
                            isDisabled={isDisabled}
                            values={this.props.availableFontSizes}
                            onChange={this.props.onIconSizeChange(this.props.layer, this.props.tagName)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.buttons[ownProps.layer],
        ...state.theme.buttons,
        availableFontFamilies: state.theme.fonts
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontSizeChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_SIZE,
                    layer: layer,
                    target: target,
                    size: event.target.value
                });
        },
        onIconSizeChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_ICON_SIZE,
                    layer: layer,
                    target: target,
                    size: event.target.value
                });
        },
        onTextTransformChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_TEXT_TRANSFORM,
                    layer: layer,
                    target: target,
                    textTransform: event.target.value
                });
        },
        onTextDecorationChange: (layer, target, level) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_TEXT_DECORATION,
                    layer: layer,
                    target: target,
                    textDecoration: event.target.value,
                    level: level
                });
        },
        onFontWeightChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_WEIGHT,
                    layer: layer,
                    target: target,
                    weight: event.target.value
                });
        },
        onFontStyleChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_STYLE,
                    layer: layer,
                    target: target,
                    style: event.target.value
                });
        },
        onFontColorChange: (layer, target, level) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value,
                    level: level
                });
        },
        onIconColorChange: (layer, target, level) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINKICON_ICON_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value,
                    level: level
                });
        },
        onBackgroundColorChange: (layer, target, level) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_LINK_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value,
                    level: level
                });
        },
        onTextAlignChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_TEXT_ALIGN,
                    layer: layer,
                    target: target,
                    align: event.target.value
                });
        },
        onBorderWidthChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_BORDER_WIDTH,
                    layer: layer,
                    target: target,
                    borderWidth: event.target.value
                });
        },
        onBorderStyleChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_BORDER_STYLE,
                    layer: layer,
                    target: target,
                    borderStyle: event.target.value
                });
        },
        onFontPropertyChange: onThemePropChange(dispatch, 'buttons.button', dispatch =>
            dispatch({ type: CALCULATE_FONT_USAGE })
        ),
        onThemePropChange: onThemePropChange(dispatch, 'buttons.button')
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IconLinkStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/IconLinkStyles.js